import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalyticsListeners, trackPageView } from "@/lib/analytics";
import { initDataLayerListeners } from "@/lib/dataLayer";

/** Mount once in the site layout: records a page view on every route change. */
export function useAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => { initAnalyticsListeners(); initDataLayerListeners(); }, []);
  useEffect(() => { trackPageView(pathname); }, [pathname]);
}
